import * as React from 'react';
import { Svg, Path } from 'react-native-svg';
import { memo } from 'react';
import type { IconProps } from '../helpers/icon-props';

const Icon = (props: IconProps) => {
  const { size = 24, ...otherProps } = props;
  return (
    <Svg width={size} height={size} viewBox="0 0 512 512" {...otherProps}>
      <Path
        d="M496.077 345.043C506.368 317.311 512 287.314 512 256s-5.632-61.311-15.923-89.043L256 144.696 15.923 166.957C5.633 194.689 0 224.686 0 256s5.633 61.311 15.923 89.043L256 367.304z"
        fill="#6da544"
      />
      <Path
        d="M496.077 166.957C459.906 69.472 366.071 0 256 0S52.094 69.472 15.923 166.957z"
        fill="#ffda44"
      />
      <Path
        d="M256 512c110.071 0 203.906-69.472 240.077-166.957H15.923C52.094 442.528 145.929 512 256 512"
        fill="#d80027"
      />
      <Path
        d="M431.549 216.586H297.442L256 89.043l-41.442 127.543H80.451l108.495 78.826-41.442 127.545L256 345.043l108.496 77.913-41.441-127.545z"
        fill="#f0f0f0"
      />
    </Svg>
  );
};
Icon.displayName = 'Myanmar';
export const Myanmar = memo<IconProps>(Icon);
